// extracted by mini-css-extract-plugin
export default {"date-time-box":"SeminarDateTime_date-time-box__jqt8k","blinker":"SeminarDateTime_blinker__M++Kh"};